import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as ReverbLink } from '@reverb-ui/react';

type LinkProps = {
  children: React.ReactNode;
  path?: string;
  isExternal?: boolean
};

export const Link = ({ children, path, isExternal }: LinkProps) => {
  return (
    <ReverbLink
      as={RouterLink}
      isExternal={isExternal}
      {...{
        to: `${path}`,
      }}
    >
      {children}
    </ReverbLink>
  );
};
